import { TICKS_PER_BAR, TICKS_PER_BEAT } from '../../shared/tempo';
import type { ClassDefinition, UpgradeDefinition } from '../types';

export interface EchoAttack {
  kind: 'echo';
  damage: number;
  cooldownTicks: number;
  speed: number;
  radius: number;
  rangeTicks: number;
  pierce: number;
  spreadRadians: number;
  delayBeats: number;
  echoes: readonly number[];
  fade: number;
}

export interface HalfTimeEffect {
  kind: 'halfTime';
  bars: number;
  radius: number;
}

export const BABACOOL: ClassDefinition = {
  id: 'babacool',
  name: 'Le Babacool',
  role: 'Ses notes repartent en échos comme un delay de dub, et rien ne le ralentit.',
  color: '#f2a65a',
  maxHp: 130,
  speed: 6.6,
  radius: 14,
  pickupRadius: 120,
  slowMul: 0,
  attack: {
    kind: 'echo',
    damage: 24,
    cooldownTicks: TICKS_PER_BEAT,
    speed: 12,
    radius: 7,
    rangeTicks: 25,
    pierce: 0,
    spreadRadians: 0.2,
    delayBeats: 1,
    echoes: [0.6, 0.35],
    fade: 0.6,
  },
  skill: {
    id: 'half-time',
    name: 'Half-time',
    description: 'Tout ralentit autour de toi, sauf tes échos, qui se répètent une fois de plus.',
    cooldownTicks: 5 * TICKS_PER_BAR,
    effect: { kind: 'halfTime', bars: 1, radius: 200 },
  },
  affinityWeaponIds: ['ruban-arc-en-ciel'],
  excludedWeaponIds: ['monocycle'],
};

export const BABACOOL_UPGRADES: readonly UpgradeDefinition[] = [
  {
    id: 'chambre-d-echo',
    name: 'Chambre d’écho',
    description: 'Tes notes ont un écho de plus.',
    family: 'class',
    classId: 'babacool',
    modifiers: [{ stat: 'echoCountAdd', add: 1 }],
    rarities: {
      rare: {
        description: 'Tes notes ont deux échos de plus.',
        modifiers: [{ stat: 'echoCountAdd', add: 2 }],
      },
      legendary: {
        description: 'Tes notes ont trois échos de plus.',
        modifiers: [{ stat: 'echoCountAdd', add: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'reinjection',
    name: 'Réinjection',
    description: 'Tes échos frappent plus fort.',
    family: 'class',
    classId: 'babacool',
    modifiers: [{ stat: 'echoPowerMul', mul: 1.2 }],
    rarities: {
      rare: {
        description: 'Tes échos frappent nettement plus fort.',
        modifiers: [{ stat: 'echoPowerMul', mul: 1.35 }],
      },
      legendary: {
        description: 'Tes échos frappent moitié plus fort.',
        modifiers: [{ stat: 'echoPowerMul', mul: 1.5 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'plein-air',
    name: 'Plein air',
    description: 'Ta spéciale s’étend plus loin autour de toi.',
    family: 'class',
    classId: 'babacool',
    modifiers: [{ stat: 'skillRadiusMul', mul: 1.2 }],
    rarities: {
      rare: {
        description: 'Ta spéciale s’étend nettement plus loin autour de toi.',
        modifiers: [{ stat: 'skillRadiusMul', mul: 1.35 }],
      },
      legendary: {
        description: 'Ta spéciale s’étend moitié plus loin autour de toi.',
        modifiers: [{ stat: 'skillRadiusMul', mul: 1.5 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'temps-suspendu',
    name: 'Temps suspendu',
    description: 'Ta spéciale dure plus longtemps.',
    family: 'class',
    classId: 'babacool',
    modifiers: [{ stat: 'skillPowerMul', mul: 1.5 }],
    rarities: {
      rare: {
        description: 'Ta spéciale dure bien plus longtemps.',
        modifiers: [{ stat: 'skillPowerMul', mul: 1.75 }],
      },
      legendary: {
        description: 'Ta spéciale dure deux fois plus longtemps.',
        modifiers: [{ stat: 'skillPowerMul', mul: 2 }],
      },
    },
    maxStacks: 2,
  },
];
